"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
var _vuex = require("vuex");
var _UserCard = _interopRequireDefault(require("./components/UserCard"));
var _user = require("@/api/user");
var _coin = require("@/api/coin");
var _cookie = require("@/utils/cookie");
var _log = require("@/utils/log");
var _ga = require("@/utils/ga");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UserEdit',
  components: {
    UserCard: _UserCard.default
  },
  data() {
    return {
      dialogVisible: false,
      user: {},
      coin: {},
      totalCoin: 0,
      coinTx: {
        category: 'other',
        amount: 0
      },
      coinCategory: ['new-account', 'reg', 'referral', 'vip', 'daily-redeem', 'baseline', 'practice', 'lifehikes-moment', 'ilt', 'game', 'talk-like-a-pro', 'revise', 'other']
    };
  },
  computed: {
    ...(0, _vuex.mapGetters)(['name', 'avatar', 'roles', 'introduction', 'email'])
  },
  created() {
    const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
    const uuid = typeof this.$route.params.id === 'undefined' ? this.user.uuid : this.$route.params.id;

    // console.log('page-useredit-uuid', this.$route.params.id)
    this.getUser(token, uuid);
    this.getUserCoin(token, uuid, false);
  },
  methods: {
    getUser(token, uuid) {
      (0, _user.getUser)(token, uuid).then(response => {
        // console.log('page-useredit-response', response.data)
        this.user = response.data;
      }).catch(err => {
        (0, _log.showDebugLog)('page-user-err', err);
        (0, _log.displayPopupMessage)(err, 'error');
      });
    },
    getUserCoin(token, uuid) {
      (0, _coin.getUserCoin)(token, uuid, false).then(response => {
        // console.log('page-useredit-coin-response', response.data)
        this.coin = response.data;
        // console.log('coin', this.coin)
        this.getTotal();
      }).catch(err => {
        (0, _log.showDebugLog)('page-user-err', err);
        (0, _log.displayPopupMessage)(err, 'error');
      });
    },
    getTotal() {
      this.totalCoin = 0;
      this.coin.transaction.forEach(tx => {
        // console.log('coin', tx.amount)
        this.totalCoin += tx.amount;
      });
    },
    update() {
      this.dialogVisible = true;
    },
    addCoinTx() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const uuid = typeof this.$route.params.id === 'undefined' ? this.user.uuid : this.$route.params.id;
      const email = (0, _cookie.getCookie)('EMAIL');
      (0, _coin.updateUserCoin)(token, uuid, this.coinTx).then(response => {
        this.getUserCoin(token, uuid);
        this.dialogVisible = false;
        this.coinTx.category = 'other';
        (0, _log.displayPopupMessage)('User\'s Coin has been adjusted successfully', 'success');
        (0, _ga.writeGaEvent)(this, 'User', 'Update User Coin', email, `User Profile: ${uuid}`);
      }).catch(error => {
        (0, _log.showDebugLog)('Page-usercoin-update-Err', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    resetCoinTxValue() {
      this.coinTx.category = 'other';
      this.coinTx.amount = 0;
    }
  }
};